import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Kaleb Cooke',
      position: 'CEO, TechStart Inc.',
      company: 'TechStart',
      rating: 5,
      text: 'Working with this team has been an absolute game-changer for our business. They delivered a scalable solution that exceeded our expectations in every way.',
      avatar: 'SJ'
    },
    {
      id: 2,
      name: 'Michael Chen',
      position: 'CTO, InnovateLabs',
      company: 'InnovateLabs',
      rating: 5,
      text: 'Exceptional technical expertise and outstanding project management. They transformed our complex requirements into an elegant, user-friendly application.',
      avatar: 'MC'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      position: 'Product Manager, CloudFlow',
      company: 'CloudFlow',
      rating: 5,
      text: 'The level of professionalism and dedication shown throughout our project was remarkable. They truly understood our vision and brought it to life beautifully.',
      avatar: 'ER'
    },
    {
      id: 4,
      name: 'David Park',
      position: 'Founder, StartupX',
      company: 'StartupX',
      rating: 5,
      text: 'Best development team we\'ve worked with. Fast, reliable, and always going the extra mile. Our app launch was a huge success thanks to their expertise.',
      avatar: 'DP'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonials" id="testimonials" ref={ref}>
      <div className="testimonials-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="section-tag">Client Success Stories</span>
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-description">
            Trusted by leading companies around the world
          </p>
        </motion.div>

        <div className="testimonials-carousel">
          <motion.button
            className="carousel-btn prev"
            onClick={prevTestimonial}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronLeft />
          </motion.button>

          <div className="carousel-content">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                className="testimonial-card"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
              >
                <div className="quote-icon">
                  <FaQuoteLeft />
                </div>

                <div className="rating">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <FaStar key={i} className="star" />
                  ))}
                </div>

                <p className="testimonial-text">
                  "{testimonials[currentIndex].text}"
                </p>

               
              </motion.div>
            </AnimatePresence>
          </div>

          <motion.button
            className="carousel-btn next"
            onClick={nextTestimonial}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaChevronRight />
          </motion.button>
        </div>

        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <motion.button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>


      </div>
    </section>
  );
};

export default Testimonials;
